module.exports = __webpack_public_path__ + "static/media/44635449_2199900406751805_9176731874590982144_o.200e8c54.jpg";